import {Table, Space} from 'antd'

import {TRANSACTION_NAME, Transaction} from 'modules/project'
import {Box, Button} from 'common/components'
import {formatMoney, createReport, formatDate} from 'common/helpers'

interface TestResultProps {
  result: any
}

export default function TestResult({result}: TestResultProps) {
  const handleScheduleReportCreate = () =>
    createReport(
      getReportData(result.finalSchedule),
      'Schedule report',
      'schedule-report'
    )

  const handleLineFeeReportCreate = () =>
    createReport(
      getReportData(result.lineFeeSchedule),
      'Line fee report',
      'line-fee-report'
    )

  return (
    <Box fadeIn mt={36}>
      <Table
        pagination={false}
        columns={columns}
        dataSource={[{key: '', ...result}]}
      />
      <Box align="right" mt={24}>
        <Space size={12}>
          <Button onClick={handleScheduleReportCreate}>
            Create Schedule report
          </Button>
          <Button onClick={handleLineFeeReportCreate}>
            Create Line Fee report
          </Button>
        </Space>
      </Box>
    </Box>
  )
}

const getReportData = (data: any[]) =>
  data.map((item, index) => ({
    '#': index + 1,
    Transaction: TRANSACTION_NAME[item.type as Transaction],
    Date: formatDate(item.date),
    Amount: item.value,
    Balance: item.balanceAfter,
    Notes: item.notes,
  }))

const columns: any[] = [
  {
    title: 'Months',
    dataIndex: 'months',
  },
  {
    title: 'Days',
    dataIndex: 'days',
  },
  {
    title: 'Facility limit 1',
    dataIndex: 'facilityLimit1',
    render: (value: number) => formatMoney(value, {cents: true}),
  },
  {
    title: 'Facility limit 2',
    dataIndex: 'facilityLimit2',
    render: (value: number) => formatMoney(value, {cents: true}),
  },
  {
    title: 'Irr',
    dataIndex: 'irr',
    render: (value: number) => `${value}%`,
  },
  {
    title: 'Lvr',
    dataIndex: 'lvr',
    render: (value: number) => `${value}%`,
  },
  {
    title: 'Total line fee',
    dataIndex: 'totalLineFee',
    render: (value: number) => formatMoney(value, {cents: true}),
  },
  {
    title: 'Total interest',
    dataIndex: 'totalInterest',
    render: (value: number) => formatMoney(value, {cents: true}),
  },
]
